import { Collapsible } from '@/components/shared/Collapsible';
import { Breadcrumb } from '@/components/shared/Breadcrumb';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ProgressNote } from '@/components/panels/ProgressNote';
import { ExportButton } from '@/components/panels/ExportButton';
import { SessionHistory } from '@/components/panels/SessionHistory';
import { AuditTrail } from '@/components/panels/AuditTrail';

/**
 * Documentation screen: chartable output of a session (SCREENMAP §4).
 * 4 panels (Progress note, Export, Session history, Audit trail); 0–1 collapsibles.
 * Educational/how-to content has been moved to the Reference screen.
 */
export function DocumentationScreen(): JSX.Element {
  return (
    <div className="screen" data-testid="docs-screen">
      <Breadcrumb />
      <h1 className="screen-title">Documentation</h1>

      <ErrorBoundary label="Progress note">
        <ProgressNote />
      </ErrorBoundary>

      <ErrorBoundary label="Export">
        <ExportButton />
      </ErrorBoundary>

      <Collapsible title="About sessions & audit" defaultOpen={false}>
        <p className="hint-text">
          Each patient encounter can be saved as a session. All changes to inputs and
          overrides are logged as audit entries with timestamps and cryptographic hashes
          for traceability.
        </p>
      </Collapsible>

      <ErrorBoundary label="Session history">
        <SessionHistory />
      </ErrorBoundary>

      <ErrorBoundary label="Audit trail">
        <AuditTrail />
      </ErrorBoundary>
    </div>
  );
}
